'use strict';

import BaseService from './base.service';

class QuotesService extends BaseService {
    /* @ngInject */
    constructor(Quote, SegaUser) {
        super(Quote, SegaUser);
        Object.assign(this, {Quote});
        this.defaultOrder = 'createdAt DESC';
    }

    createProcedureFromTpl(
        opts = {
            quote: null,
            procedureTemplate: null
        }
    ) {
        let altQ = new this.Quote({
            id: opts.quote.id
        });
        return altQ.$prototype$createProcedureFromTpl({
            procedureTemplateId: opts.procedureTemplate.id
        });
    }

    getModels(opts = {}) {
        return this.getQueryOpts(opts).then((queryOpts) => {
            return this.Model.quoteFind({
                filter: queryOpts
            }).$promise;
        });
    }
}

export default QuotesService;
